import React from 'react'

export const GroupContext = React.createContext()

export default function GroupContextProvider({ value, children }) {
  return <GroupContext.Provider value={value}>{children}</GroupContext.Provider>
}
